import { useEffect } from 'react';
import { Header } from './header/Header';
import { InputSection } from './input/InputSection';
import { PreviewSection } from './preview/PreviewSection';
import { SelectSection } from './select/SelectSection';
import { Footer } from './footer/Footer';
import { SelectionContext, useSelectionState } from 'src/contexts/SelectionContext';
import { EmbeddedContext } from 'src/contexts/EmbeddedContext';
import { useEmbeddedMode } from 'src/hooks/useEmbeddedMode';
import styles from './CampaignAutomationPage.module.css';
import { ClientContextProvider } from 'src/contexts/ClientContextProvider';
import { AssetContextProvider } from 'src/contexts/AssetContextProvider';
import { CampaignCreationSection } from './create/CampaignCreationSection';
import { CampaignMetadataContextProvider } from 'src/contexts/CampaignMetadataContextProvider';
import { EmbeddedDoneButton } from './embedded/EmbeddedDoneButton';

const CampaignAutomationPage = () => {
  const { isEmbedded, embeddedPlacement, embeddedDeviceFamily, embeddedMarketplace } =
    useEmbeddedMode();
  const selectionState = useSelectionState();
  const { setPlacement, setDeviceFamily, setMarketplace } = selectionState;

  useEffect(() => {
    if (!isEmbedded) return;
    if (embeddedPlacement) setPlacement(embeddedPlacement);
    if (embeddedDeviceFamily) setDeviceFamily(embeddedDeviceFamily);
    if (embeddedMarketplace) setMarketplace(embeddedMarketplace);
  }, [
    isEmbedded,
    embeddedPlacement,
    embeddedDeviceFamily,
    embeddedMarketplace,
    setPlacement,
    setDeviceFamily,
    setMarketplace,
  ]);

  return (
    <EmbeddedContext.Provider value={{ isEmbedded }}>
      <div className={styles.provider}>
        <ClientContextProvider>
          <SelectionContext.Provider value={selectionState}>
            <AssetContextProvider>
              <main className={styles.page}>
                <Header />
                <SelectSection />
                <CampaignMetadataContextProvider>
                  <div className={styles.mainContent}>
                    <div className={styles.leftColumn}>
                      <InputSection />
                      {isEmbedded && <EmbeddedDoneButton />}
                      {!isEmbedded && <CampaignCreationSection />}
                    </div>
                    <PreviewSection />
                  </div>
                </CampaignMetadataContextProvider>
                {!isEmbedded && <Footer />}
              </main>
            </AssetContextProvider>
          </SelectionContext.Provider>
        </ClientContextProvider>
      </div>
    </EmbeddedContext.Provider>
  );
};

export { CampaignAutomationPage };
